/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import "../theme/Reclasificacion.css";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import imgCierre from "../assets/cargaTusCierresdeLote.png";
import imgDeposito from "../assets/cargaFichaDeposito.png";
import imgEntrega from "../assets/cargaFichaEntregaVaores.png";
import iconoReporteVentas from "../assets/cargaReporteVentas.png";
import iconoCofreElectronico from "../assets/cargaCofreElectronico.png";

import iconEfectivo from "../assets/icon-efectivo.svg";
import iconDepositosEfectivo from "../assets/icon-dispositivos-efectivo.svg";
import iconCofreElectronico from "../assets/icon-cofre-electronico.svg";
import iconEntregaValores from "../assets/icon-entrega-valores.svg";
import iconFichaDeposito from "../assets/icon-ficha-deposito.svg";
import iconPinPad from "../assets/icon-lote-pin-pad.svg";
import iconReporteVentas from "../assets/icon-reporte-ventas.svg";

import { TextCierredeDiaFormSeparador } from "./TextCierredeDiaFormSeparador";
//import Modal from "react-responsive-modal";
import { fetchUploadUrl } from "../Api/fetchUploadUrl";
import { LoadingSpinner } from "./LoadingSpinner";
import { fetchBitacora } from "../Api/fetchBitacora";
import { fetchReclasificacionEdit } from "../Api/fetchReclasificacionEdit";
import { fetchReclasificacionCatalogoDias } from "../Api/fetchReclasificacionCatalogoDias";
import { Modal, Image } from "antd";
import { UseAdmin, UseUser, UseAuth } from "../hooks";
import axios from "axios";
import Switch from "react-switch";
import { NumericFormat } from "react-number-format";
import { VERSION_APP } from "../utilities";
import compressImage from "../utils/CompressImage";
import { IMAGE_UPLOAD_TYPE } from "./ReclasificacionIngresosForm";
import { ModalCofreElectronico } from "./Modals/CierreDia/ModalCofreElectronico";
import { ModalReporteVentas } from "./Modals/CierreDia/ModalReporteVentas";
import iconTarjetas from "../assets/icon-tarjetas.svg";
import iconValesFisicos from "../assets/icon-vales-fisicos.svg";
import iconAgregaores from "../assets/icon-agregadores.svg";
import iconOtros from "../assets/icon-otros.svg";

registerLocale("es", es);

export const ReclasificacionIngresosFormEdith = (props) => {
  // No se quien hizo esto, pero es un infierno de mantenimiento lo que creó aquí,
  // +2k de lineas de codigo, duplicadas, usandose ambos componentes, con logica compleja dentro del componente,
  // vamos... una joya
  const { info, formasPago, fecha } = props;
  const [errors, setErrors] = useState({});
  const { uniqueId } = UseAuth();
  const { brandfiMarcaId, branchFiSucursalId, branchFiPaisId, branchFcNombre } = UseAdmin();
  const { employeeId, mail, device } = UseUser();
  ///Datos de dispositivo
  const [deviceInfo, setDeviceInfo] = useState(null);
  ///Datos de location
  const [locationLatitude, setLocationLatitude] = useState(null);
  const [locationLongitude, setLocationLongitude] = useState(null);

  ///Datos para dia de recolecion
  const [isDiaRecolecion, setIsDiaRecolecion] = useState();

  //Datos para imagenes
  const imageUrlnoNull = info.records.urlCierreLote === "Null" ? null : info.records.urlCierreLote;

  const imagenValoresUrlnoNull =
    info.records.urlImagenEntregaValores === "Null" ? null : info.records.urlImagenEntregaValores;

  const imagenDepositoUrlNull =
    info.records.urlImagenFichaDeposito === "Null" ? null : info.records.urlImagenFichaDeposito;

  const imagenCofreElectronicoUrlNull =
    info.records.urlImagenCofreElectronico === "Null"
      ? null
      : info.records.urlImagenCofreElectronico;

  const imagenReporteVentasUrlNull =
    info.records.urlImagenVentas === "Null" ? null : info.records.urlImagenVentas;

  const [isShowImage, setIsShowImage] = useState(false);
  const [isShowImageDep, setIsShowImageDep] = useState(false);
  const [isShowImageVal, setIsShowImageVal] = useState(false);
  const [isShowImageCofreElectronico, setIsShowImageCofreElectronico] = useState(false);
  const [isShowImageReporteVentas, setIsShowImageReporteVentas] = useState(false);

  const [modalVisibleFicha, setModalVisibleFicha] = useState(false);
  const [modalVisibleValores, setModalVisibleValores] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleCofreElectronico, setModalVisibleCofreElectronico] = useState(false);
  const [modalVisibleReporteVentas, setModalVisibleReporteVentas] = useState(false);
  const [imageURL, setImageURL] = useState(imageUrlnoNull);
  const [imageDepositoURL, setImageDepositoURL] = useState(imagenDepositoUrlNull);
  const [imageValoresURL, setImageValoresURL] = useState(imagenValoresUrlnoNull);
  const [imageCofreElectronicoURL, setImageCofreElectronicoURL] = useState(
    imagenCofreElectronicoUrlNull
  );
  const [imageReporteVentasURL, setImageReporteVentasURL] = useState(imagenReporteVentasUrlNull);
  const [image, setImage] = useState(null);
  const [imageValores, setImageValores] = useState(null);
  const [imageDeposito, setImageDeposito] = useState(null);
  const [imageCofreElectronico, setImageCofreElectronico] = useState(null);
  const [imageReporteVentas, setImageReporteVentas] = useState(null);
  const enableTicket = imagenValoresUrlnoNull !== null ? false : true;
  const [checked, setChecked] = useState(enableTicket);
  const [suma, setSuma] = useState();
  const [efectivoDepositar, setEfectivoDepositar] = useState();
  const [propina, setPropina] = useState(info.records.propina);
  const [nombre, setNombre] = useState(info.records.nombreGerente);
  const [formDataLoaded, setFormDataLoaded] = useState(false);
  const [datosEnviados, setDatosEnviados] = useState(false);
  const textComent =
    info.records.comentarios === "None" ||
    info.records.comentarios === null ||
    info.records.comentarios === undefined
      ? ""
      : info.records.comentarios;
  const dataTicket =
    info.records.noTicket === "None" ||
    info.records.noTicket === null ||
    info.records.noTicket === undefined
      ? ""
      : info.records.noTicket;
  const [comentario, setComentario] = useState(textComent);
  const [noTicket, setnoTicket] = useState(dataTicket);
  const [ImagenChangeCierre, setImagenChangeCierre] = useState(false);
  const [ImagenChangeFicha, setImagenChangeFicha] = useState(false);
  const [ImagenChangeValores, setImagenChangeValores] = useState(false);
  const [ImagenChangeCofreElectronico, setImagenChangeCofreElectronico] = useState(false);
  const [ImagenChangeReporteVentas, setImagenChangeReporteVentas] = useState(false);
  const [shouldShowCofreElectronico, setShouldShowCofreElectronico] = useState(false);

  const [formData, setFormData] = useState({
    amex: info.records.formaPagoReclasificacion[0].cantidad,
    tpv: info.records.formaPagoReclasificacion[1].cantidad,
    pinpad: info.records.formaPagoReclasificacion[2].cantidad,
    vales: info.records.formaPagoReclasificacion[3].cantidad,
    valescdmx: info.records.formaPagoReclasificacion[4].cantidad,
    delivery: info.records.formaPagoReclasificacion[5].cantidad,
    didi: info.records.formaPagoReclasificacion[6].cantidad,
    didicredito: info.records.formaPagoReclasificacion[7].cantidad,
    rappi: info.records.formaPagoReclasificacion[8].cantidad,
    rapicargo: info.records.formaPagoReclasificacion[9].cantidad,
    uber: info.records.formaPagoReclasificacion[10].cantidad,
    uberdirect: info.records.formaPagoReclasificacion[11].cantidad,
    mercadopago: info.records.formaPagoReclasificacion[12].cantidad,
    wow: info.records.formaPagoReclasificacion[13].cantidad,
    mop: info.records.formaPagoReclasificacion[14].cantidad,
    startbuckRegords: info.records.formaPagoReclasificacion[15].cantidad,
    scanpay: info.records.formaPagoReclasificacion[16].cantidad,
    bkapp: info.records.formaPagoReclasificacion[17].cantidad,
    eventosWalmart: info.records.formaPagoReclasificacion[18].cantidad,
    eventosEmpresariales: info.records.formaPagoReclasificacion[19].cantidad,
    efectivomxp: info.records.formaPagoReclasificacion[20].cantidad,
    efectivousd: info.records.formaPagoReclasificacion[21].cantidad,
    didiEfectivo:
      info.records.formaPagoReclasificacion.length >= 23
        ? info.records.formaPagoReclasificacion[22].cantidad
        : "",
    uberEfectivo:
      info.records.formaPagoReclasificacion.length >= 24
        ? info.records.formaPagoReclasificacion[23].cantidad
        : "",
    rappiEfectivo:
      info.records.formaPagoReclasificacion.length >= 25
        ? info.records.formaPagoReclasificacion[24].cantidad
        : "",
    anticipoOtrosCreditos:
      info.records.formaPagoReclasificacion.length >= 26
        ? info.records.formaPagoReclasificacion[25].cantidad
        : "",
    otrosCreditos:
      info.records.formaPagoReclasificacion.length >= 27
        ? info.records.formaPagoReclasificacion[26].cantidad
        : "",
    deliverySr:
      info.records.formaPagoReclasificacion.length >= 28
        ? info.records.formaPagoReclasificacion[27].cantidad
        : "",
  });

  const handleChangCheck = () => {
    setChecked(!checked);
  };

  const handleChangeNombre = (event) => {
    setNombre(event.target.value);
  };

  ///formate de hora
  const date = new Date();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let segundos = date.getSeconds();
  hour = hour < 10 ? `0${hour}` : hour;
  minute = minute < 10 ? `0${minute}` : minute;
  segundos = segundos < 10 ? `0${segundos}` : segundos;

  const hoyfecha = `${fecha} ${hour}:${minute}:${segundos}`;

  const handleValueChange = (values, nombreCampo) => {
    setFormData({
      ...formData,
      [nombreCampo]: values.floatValue,
    });
  };

  const [formDataNoSuma, setformDataNoSuma] = useState({
    VTotal: info.records.ventaTotal,
    depostitoTombola: info.records.depositoTombola,
    propinpor: info.records.porcentajePropina,
  });

  const handleChangeNoSuma = (values, nombreCampo) => {
    console.log("values", values);
    console.log("nombreCampo", nombreCampo);
    setformDataNoSuma({
      ...formDataNoSuma,
      [nombreCampo]: values.floatValue,
    });
  };

  const handleChangeComentario = (event) => {
    const inputValue = event.target.value;
    setComentario(inputValue.slice(0, 300));
  };
  const handleChangeTicket = (event) => {
    const inputValue = event.target.value;
    setnoTicket(inputValue.slice(0, 12));
  };

  useEffect(() => {
    // Calcula la suma total cuando cambian los valores de los campos
    const total = Object.values(formData).reduce((acumulador, valor) => {
      // Convierte el valor a número (usando parseFloat para valores decimales)
      const numeroValor = parseFloat(valor);

      // Verifica si es un número válido antes de sumarlo
      if (!isNaN(numeroValor)) {
        return acumulador + numeroValor;
      } else {
        return acumulador;
      }
    }, 0);

    /*// Resta el valor VTotal (asegúrate de convertirlo también)
        const VTotalNumero = parseFloat(formDataNoSuma.VTotal);
        const depositoTombola = parseFloat(formDataNoSuma.depostitoTombola);

        const sumaTotal =
          !isNaN(VTotalNumero) && !isNaN(depositoTombola)
            ? total - VTotalNumero - depositoTombola
            : total;*/

    setSuma(total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  useEffect(() => {
    setPropina((Number(formDataNoSuma.propinpor) * Number(suma)) / 100);
  }, [suma, formDataNoSuma.propinpor]);

  useEffect(() => {
    setEfectivoDepositar(
      Number(formData.efectivomxp) +
        Number(formData.efectivousd) -
        Number(formDataNoSuma.depostitoTombola)
    );
  }, [formData.efectivomxp, formDataNoSuma.depostitoTombola, formData.efectivousd]);

  useEffect(() => {
    // Función para cargar los datos del formulario al abrir la aplicación
    const loadFormData = async () => {
      try {
        // Obtener los datos del formulario guardados en AsyncStorage
        const saveDataLocal = `formData-${fecha}`;
        const savedFormData = localStorage.getItem(saveDataLocal);

        if (savedFormData) {
          // Si se encuentran datos guardados, analizarlos y establecerlos en el estado
          const parsedFormData = JSON.parse(savedFormData);
          setFormData(parsedFormData.formData);
          setImageURL(parsedFormData.imageURL);
          //setImage(parsedFormData.imageURL);
          setImageDepositoURL(parsedFormData.imageDepositoURL);
          // setImageDeposito(parsedFormData.imageDepositoURL);
          setImageValoresURL(parsedFormData.imageValoresURL);
          //setImageValores(parsedFormData.imageValoresURL);
          setImageCofreElectronicoURL(parsedFormData.imageCofreElectronicoURL);
          setImageReporteVentasURL(parsedFormData.imageReporteVentasURL);
          setNombre(parsedFormData.nombre);
          //setComentario(parsedFormData.comentario);
          setformDataNoSuma(parsedFormData.formDataNoSuma);
          alert("Datos de cierre de día pendientes por enviar");
        }
      } catch (error) {
        //console.error("Error al cargar los datos del formulario:", error);
      } finally {
        setFormDataLoaded(true);
      }
    };

    if (!formDataLoaded && !datosEnviados) {
      loadFormData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDataLoaded, datosEnviados]);

  useEffect(() => {
    // Guardar los datos del formulario en AsyncStorage
    if (formDataLoaded && !datosEnviados) {
      if (
        Object.values(formData).some((value) => value !== null) ||
        imageDepositoURL !== null ||
        imageValoresURL !== null ||
        imageURL !== null ||
        imageCofreElectronicoURL !== null ||
        imageReporteVentasURL !== null ||
        nombre !== null ||
        comentario !== "" ||
        Object.values(formDataNoSuma).some((value) => value !== null)
      ) {
        // Solo guarda los datos si al menos uno de ellos está presente
        saveDataLocally();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formData,
    formDataNoSuma,
    imageDepositoURL,
    imageValoresURL,
    imageURL,
    imageCofreElectronicoURL,
    imageReporteVentasURL,
    nombre,
    comentario,
    formDataLoaded,
    datosEnviados,
  ]);

  const saveDataLocally = async () => {
    try {
      // Guardar los datos del formulario en AsyncStorage
      const totalData = {
        formData,
        formDataNoSuma,
        imageURL,
        imageDepositoURL,
        imageValoresURL,
        imageCofreElectronicoURL,
        imageReporteVentasURL,
        nombre,
        fecha: hoyfecha,
      };
      const saveDataLocal = `formData-${fecha}`;
      localStorage.setItem(saveDataLocal, JSON.stringify(totalData));
      //console.log(`Datos guardados correctamente en ${saveDataLocal}`);
    } catch (error) {
      //console.error("Error al guardar los datos:", error);
    }
  };

  ///UseEfect para catalogo de recolecion
  useEffect(() => {
    getCatalogoRecolecion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fecha]);
  const getCatalogoRecolecion = () => {
    if (branchFiPaisId !== null && brandfiMarcaId !== null && branchFiSucursalId !== null) {
      const onFailure = (error) => {
        // console.log(error);
      };
      // console.log(fecha);
      const onSuccess = ({ data }) => {
        console.log("data", data);
        const filteredRecords = data.records.filter((record) => record.estatus === 1);
        const numerosDiaRecoleccion = filteredRecords.map((record) => record.diaRecoleccion);
        console.log(numerosDiaRecoleccion);
        ///Obtener  day format
        const dateParts = fecha.split("/");
        const year = parseInt(dateParts[2], 10);
        const month = parseInt(dateParts[1], 10) - 1;
        const day = parseInt(dateParts[0], 10);
        const date = new Date(year, month, day);
        const dayOfWeek = date.getDay();
        console.log("Numero dia", dayOfWeek);
        const encontrado = numerosDiaRecoleccion.some((item) => item === dayOfWeek);
        console.log("dia de recolecion", encontrado);
        setIsDiaRecolecion(encontrado);
        const recoleccionObj = filteredRecords.filter(
          (record) => record.diaRecoleccion === dayOfWeek
        )[0];
        const tieneCofre = recoleccionObj.cofre ? recoleccionObj.cofre === 1 : false;
        setShouldShowCofreElectronico(
          tieneCofre || imageCofreElectronicoURL !== null || imageCofreElectronicoURL !== "Null"
        );
      };
      fetchReclasificacionCatalogoDias(
        Number(branchFiPaisId),
        Number(brandfiMarcaId),
        branchFiSucursalId //sucursal ID Number
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  useEffect(() => {
    const getPublicIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setDeviceInfo(`Ip publica ${response.data.ip}`);
      } catch (error) {
        console.error("Error al obtener la IP pública:", error);
      }
    };

    getPublicIP();
  }, []);

  useEffect(() => {
    // Función para obtener la ubicación
    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocationLatitude(position.coords.latitude);
            setLocationLongitude(position.coords.longitude);
          },
          (error) => alert("Error al obtener la ubicación:", error)
        );
      } else {
        alert("Geolocalización no es soportada por este navegador.");
      }
    };

    // Llamamos a la función para obtener la ubicación al montar el componente
    getLocation();
  }, []);

  const handleImageChange = (event, setImageCallback) => {
    const file = event.target.files[0];
    // const reader = new FileReader();

    // reader.onloadend = () => {
    //   const base64String = reader.result;
    //   setImageCallback(base64String);
    // };

    // if (file) {
    //   reader.readAsDataURL(file);
    // }

    if (file) {
      compressImage(file).then((compressed) => {
        if (compressed) {
          // console.log("Image ready for upload:", compressed);
          setImageCallback(compressed);
        }
      });
    }
  };

  const handleImageChangeFicha = (event) => {
    handleImageChange(event, setImage);
  };

  const handleImageChangeDeposito = (event) => {
    handleImageChange(event, setImageDeposito);
  };

  const handleImageChangeValores = (event) => {
    handleImageChange(event, setImageValores);
  };

  const handleImageChangeCofreElectronico = (event) => {
    handleImageChange(event, setImageCofreElectronico);
  };

  const handleImageChangeReporteVentas = (event) => {
    handleImageChange(event, setImageReporteVentas);
  };

  const uploadImage = (
    type,
    imageFun,
    setImageURLFuntion,
    setIsShowImageFuntion,
    setModalVisibleFuntion
  ) => {
    setIsShowImageFuntion(true);
    const onFailure = ({ error, config }) => {
      // console.log(error);
      getBitacora(config, "Subir imagen", error);
      alert(error);
      setIsShowImageFuntion(false);
    };
    const onSuccess = ({ data, config }) => {
      //  console.log(data);
      getBitacora(config, "Subir imagen", data);
      setImageURLFuntion(data[type]);
      setModalVisibleFuntion(false);
      setIsShowImageFuntion(false);
      {
        type === "Cierre_Lote"
          ? setImagenChangeCierre(true)
          : type === "Ficha_Deposito"
            ? setImagenChangeFicha(true)
            : type === "Ficha_Entrega_Valores"
              ? setImagenChangeValores(true)
              : type === IMAGE_UPLOAD_TYPE.COFRE_ELECTRONICO
                ? setImagenChangeCofreElectronico(true)
                : type === IMAGE_UPLOAD_TYPE.REPORTE_VENTAS
                  ? setImagenChangeReporteVentas(true)
                  : "";
      }
    };
    fetchUploadUrl(
      branchFiSucursalId, //sucursal ID
      branchFcNombre,
      hoyfecha,
      type,
      imageFun
    )
      .then(onSuccess)
      .catch(onFailure);
  };

  const saveImage = () => {
    uploadImage("Cierre_Lote", image, setImageURL, setIsShowImage, setModalVisible);
  };

  const saveImageDeposito = () => {
    uploadImage(
      "Ficha_Deposito",
      imageDeposito,
      setImageDepositoURL,
      setIsShowImageDep,
      setModalVisibleFicha
    );
  };

  const saveImageValores = () => {
    uploadImage(
      "Ficha_Entrega_Valores",
      imageValores,
      setImageValoresURL,
      setIsShowImageVal,
      setModalVisibleValores
    );
  };

  const saveImageCofreElectronico = () => {
    uploadImage(
      IMAGE_UPLOAD_TYPE.COFRE_ELECTRONICO,
      imageCofreElectronico,
      setImageCofreElectronicoURL,
      setIsShowImageCofreElectronico,
      setModalVisibleCofreElectronico
    );
  };

  const saveImageReporteVentas = () => {
    uploadImage(
      IMAGE_UPLOAD_TYPE.REPORTE_VENTAS,
      imageReporteVentas,
      setImageReporteVentasURL,
      setIsShowImageReporteVentas,
      setModalVisibleReporteVentas
    );
  };

  const getBitacora = async (requestStore, description, responseData) => {
    const deviceWeb = `${uniqueId}-${device}`;
    const key = `${uniqueId}-${device}-${employeeId}`;
    const obtenerFechaEnFormato = () => {
      const ahora = moment();
      const fechaEnFormato = ahora.format("YY/MM/DD HH:mm:ss.SSS");
      return fechaEnFormato;
    };
    const fechaActualEnFormato = obtenerFechaEnFormato();
    if (brandfiMarcaId != null && requestStore != null && responseData != null) {
      const onFailure = (error) => {
        // console.log("bitacora", error);
      };

      const onSuccess = ({ data }) => {
        // console.log(description, data);
      };

      fetchBitacora(
        mail,
        deviceWeb,
        fechaActualEnFormato,
        key,
        requestStore,
        responseData,
        description,
        VERSION_APP,
        employeeId,
        brandfiMarcaId,
        branchFiSucursalId, //sucursal ID
        branchFiPaisId
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  ///Funcion para Enviar a guardar el dato

  const setSaveReclasificacionEdith = () => {
    // debugger
    //  console.log("suma", suma);

    if (!isDiaRecolecion) {
      // console.log("no dia de recolecion");
      setFormToFetch();
    } else {
      setFormToFetch();
    }

    function setFormToFetch() {
      // Validar los campos del formulario
      const errors = {};
      if (formasPago.some((item) => item === 1) && formData.amex == null) {
        //alert("Ingresa el valor de Amex");
        errors.amex = "Ingresa el valor de Amex";
        console.log(errors.amex);
      }
      if (formasPago.some((item) => item === 2) && formData.tpv == null) {
        //alert("Ingresa el valor de TPV");
        errors.tpv = "Ingresa el valor de TPV";
      }
      if (formasPago.some((item) => item === 3) && formData.pinpad == null) {
        //alert("Ingresa el valor de PinPad");
        errors.pinpad = "Ingresa el valor de PinPad";
      }
      if (formasPago.some((item) => item === 4) && formData.vales == null) {
        //alert("Ingresa el valor de Vales");
        errors.vales = "Ingresa el valor de Vales";
      }
      if (formasPago.some((item) => item === 5) && formData.valescdmx == null) {
        //alert("Ingresa el valor de Vales Cdmx");
        errors.valescdmx = "Ingresa el valor de Vales CDMX";
      }
      if (formasPago.some((item) => item === 6) && formData.delivery == null) {
        //alert("Ingresa el valor Delivery Alse");
        errors.delivery = "Ingresa el valor de Delivery Alsea";
      }
      if (formasPago.some((item) => item === 7) && formData.didi == null) {
        //alert("Ingresa el valor de Didi");
        errors.didi = "Ingresa el valor de Didi";
      }
      if (formasPago.some((item) => item === 8) && formData.didicredito == null) {
        // alert("Ingresa el valor de Didi credito");
        errors.didicredito = "Ingresa el valor de Didi Creditos";
      }
      if (formasPago.some((item) => item === 9) && formData.rappi == null) {
        // alert("Ingresa el valor de Rappi");
        errors.rappi = "Ingresa el valor de Rappi";
      }
      if (formasPago.some((item) => item === 10) && formData.rapicargo == null) {
        //alert("Ingresa el valor de Rappi cargo");
        errors.rapicargo = "Ingresa el valor de Rappi Cargo";
      }
      if (formasPago.some((item) => item === 11) && formData.uber == null) {
        //7alert("Ingresa el valor de Uber");
        errors.uber = "Ingresa el valor de Uber";
      }
      if (formasPago.some((item) => item === 12) && formData.uberdirect == null) {
        //alert("Ingresa el valor de Uber Direct");
        errors.uberdirect = "Ingresa el valor de Uber direct";
      }
      if (formasPago.some((item) => item === 13) && formData.mercadopago == null) {
        //alert("Ingresa el valor de Mercado pago");
        errors.mercadopago = "Ingresa el valor de  Mercado Pago";
      }
      if (formasPago.some((item) => item === 14) && formData.wow == null) {
        //alert("Ingresa el valor de WOw");
        errors.wow = "Ingresa el valor de Wow";
      }
      if (formasPago.some((item) => item === 15) && formData.mop == null) {
        //alert("Ingresa el valor de MOP");
        errors.mop = "Ingresa el valor de MOP";
      }
      if (formasPago.some((item) => item === 16) && formData.startbuckRegords == null) {
        //alert("Ingresa el valor de StarBucks Rewords");
        errors.startbuckRegords = "Ingresa el valor de StarBucks Rewards";
      }
      if (formasPago.some((item) => item === 17) && formData.scanpay == null) {
        //alert("Ingresa el valor de Scan & Pay");
        errors.scanpay = "Ingresa el valor de  Scan & Pay";
      }
      if (formasPago.some((item) => item === 18) && formData.bkapp == null) {
        //alert("Ingresa el valor de BK App");
        errors.bkapp = "Ingresa el valor de  BK App";
      }
      if (formasPago.some((item) => item === 19) && formData.eventosWalmart == null) {
        // alert("Ingresa el valor de Eventos Walmart");
        errors.eventosWalmart = "Ingresa el valor de Eventos Walmart";
      }
      if (formasPago.some((item) => item === 20) && formData.eventosEmpresariales == null) {
        // alert("Ingresa el valor de Eventos Empresariales");
        errors.eventosEmpresariales = "Ingresa el valor de Eventos Empresariales";
      }
      if (formasPago.some((item) => item === 21) && formData.efectivomxp == null) {
        //  alert("Ingresa el valor de Efectivo MXP");
        errors.efectivomxp = "Ingresa el valor de Efectivo MXP";
      }
      if (formasPago.some((item) => item === 22) && formData.efectivousd == null) {
        // alert("Ingresa el valor de Efectivo USD");
        errors.efectivousd = "Ingresa el valor de Efectivo USD";
      }
      if (formasPago.some((item) => item === 23) && formDataNoSuma.propinpor == null) {
        // alert("Ingresa el porcentaje de propina");
        errors.propinpor = "Ingresa el porcentaje de propina";
      }
      if (formasPago.some((item) => item === 24) && formData.didiEfectivo == null) {
        // alert("Ingresa el valor de Didi Efectivo");
        errors.didiEfectivo = "Ingresa el valor de Didi Efectivo";
      }
      if (formasPago.some((item) => item === 25) && formData.uberEfectivo == null) {
        // alert("Ingresa el valor de Uber Efectivo");
        errors.uberEfectivo = "Ingresa el valor de Uber Efectivo";
      }
      if (formasPago.some((item) => item === 26) && formData.rappiEfectivo == null) {
        ///alert("Ingresa el valor de Rappi Efectivo");
        errors.rappiEfectivo = "Ingresa el valor de Rappi Efectivo";
      }
      if (formasPago.some((item) => item === 27) && formData.anticipoOtrosCreditos == null) {
        // alert("Ingresa el valor de Anticipo y otros creditos");
        errors.anticipoOtrosCreditos = "Ingresa el valor de Anticipo y otros creditos";
      }
      if (formasPago.some((item) => item === 28) && formData.otrosCreditos == null) {
        //alert("Ingresa el valor de Otros creditos");
        errors.otrosCreditos = "Ingresa el valor de Otros creditos";
      }
      if (formasPago.some((item) => item === 29) && formData.deliverySr == null) {
        // alert("Ingresa el valor de delivery SR");
        errors.deliverySr = "Ingresa el valor de Delivery SR";
      }
      if (formDataNoSuma.VTotal == null) {
        // alert("Ingresa el valor de Venta total");
        errors.VTotal = "Ingresa el valor de Venta total";
      }
      if (nombre == null) {
        // alert("Ingresa el valor de nombre el gerente enturno");
        errors.nombre = "Ingresa en nombre el gerente en turno";
      }
      if (imageURL == null) {
        alert("Ingresa evidencia de cierre de lote");
        // errors.imageURL = "Evidencia de cierre de lote es requerida";
        return;
      }
      if (formDataNoSuma.depostitoTombola == null) {
        //alert("Ingresa el valor de deposito en tombola");
        errors.depostitoTombola = "Ingresa el valor de Deposito en tombola";
      }
      if (formData.efectivomxp > 0 && imageDepositoURL == null) {
        alert("Ingresa evidencia de ficha depósito");
        //errors.imageDepositoURL = "Evidencia de ficha depósito es requerida";
        return;
      }
      if (isDiaRecolecion) {
        console.log("es dia de recolecion");
        if (imageValoresURL != null || !isNaN(parseInt(noTicket, 10))) {
          // Aquí deberías poner lo que quieres hacer si se cumple la condición
          console.log(imageValoresURL != null || !isNaN(parseInt(noTicket, 10)));
        } else {
          alert("Ingresar una evidencia de entrega a valores o el número de #ticket");
          return;
        }
      }
      if (shouldShowCofreElectronico && imageCofreElectronicoURL == null) {
        alert("Ingrese imagen de cofre electrónico");
        return;
      }
      if (imageReporteVentasURL == null) {
        alert("Ingrese imagen de reporte de ventas");
        return;
      }

      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      } else {
        setErrors("");
        validaIguales();
      }

      function validaIguales() {
        ///suma nueva
        console.log("total suma", suma);
        console.log("vtotal", formDataNoSuma.VTotal);

        const vnTotal = formDataNoSuma.VTotal;
        const nTotal = Number(suma.toFixed(2));

        console.log(vnTotal);
        console.log(nTotal);
        if (Number(vnTotal) !== nTotal) {
          alert("Venta Total y Total deben ser iguales");
        } else {
          allValidateReadytoSet();
        }
      }

      function allValidateReadytoSet() {
        const valoresImg = imageValoresURL !== null ? imageValoresURL : "Null";
        const cofreElectronicoImg =
          imageCofreElectronicoURL !== null ? imageCofreElectronicoURL : "Null";
        const reporteVentasImg = imageReporteVentasURL !== null ? imageReporteVentasURL : "Null";
        const ticketno = !noTicket ? "None" : noTicket;

        const depositoImg = imageDepositoURL !== null ? imageDepositoURL : "Null";

        const mop = formData.mop !== null ? formData.mop : 0;
        const startbuckRe = formData.startbuckRegords !== null ? formData.startbuckRegords : 0;
        const scanypay = formData.scanpay !== null ? formData.scanpay : 0;
        const bkapp = formData.bkapp !== null ? formData.bkapp : 0;
        const eventosWalmart = formData.eventosWalmart !== null ? formData.eventosWalmart : 0;
        const eventosEmpresariales =
          formData.eventosEmpresariales !== null ? formData.eventosEmpresariales : 0;
        const efectivousd = formData.efectivousd !== null ? formData.efectivousd : 0;

        const porpropina = formDataNoSuma.propinpor !== null ? formDataNoSuma.propinpor : 0;
        const propinatotal = propina !== null ? propina : 0;
        const didiEfectivo = formData.didiEfectivo !== null ? formData.didiEfectivo : 0;
        const uberEfectivo = formData.uberEfectivo !== null ? formData.uberEfectivo : 0;
        const rappiEfectivo = formData.rappiEfectivo !== null ? formData.rappiEfectivo : 0;
        const anticioOtros =
          formData.anticipoOtrosCreditos !== null ? formData.anticipoOtrosCreditos : 0;
        const otrosCreditos = formData.otrosCreditos !== null ? formData.otrosCreditos : 0;
        const deliverySr = formData.deliverySr !== null ? formData.deliverySr : 0;
        const comentText = comentario !== null ? comentario : "None";
        const cierreFecha =
          ImagenChangeCierre === false ? info.records?.detallevidencia[0].fechaEstatus : hoyfecha;
        const fichaFecha =
          ImagenChangeCierre === false ? info.records?.detallevidencia[1].fechaEstatus : hoyfecha;
        const valoresFecha =
          ImagenChangeCierre === false ? info.records?.detallevidencia[2].fechaEstatus : hoyfecha;
        const cofreElectronicoFecha =
          ImagenChangeCofreElectronico === false
            ? info.records?.detallevidencia[3]?.fechaEstatus
            : hoyfecha;
        const reporteVentasFecha =
          ImagenChangeReporteVentas === false
            ? info.records?.detallevidencia[4]?.fechaEstatus
            : hoyfecha;

        const cierreType =
          ImagenChangeCierre === false
            ? info.records?.detallevidencia[0].statusEvidencia
            : info.records?.detallevidencia[0].statusEvidencia === "1"
              ? "2"
              : info.records?.detallevidencia[0].statusEvidencia;
        const fichaType =
          ImagenChangeFicha === false
            ? info.records?.detallevidencia[1].statusEvidencia
            : info.records?.detallevidencia[1].statusEvidencia === "1"
              ? "2"
              : info.records?.detallevidencia[1].statusEvidencia;
        const valoresType =
          ImagenChangeValores === false
            ? info.records?.detallevidencia[2].statusEvidencia
            : info.records?.detallevidencia[2].statusEvidencia === "1"
              ? "2"
              : info.records?.detallevidencia[2].statusEvidencia;
        const cofreElectronicoType =
          ImagenChangeCofreElectronico === false
            ? info.records?.detallevidencia[3]?.statusEvidencia
            : info.records?.detallevidencia[3]?.statusEvidencia === "1"
              ? "2"
              : info.records?.detallevidencia[3]?.statusEvidencia;

        const reporteVentasType =
          ImagenChangeReporteVentas === false
            ? info.records?.detallevidencia[4]?.statusEvidencia
            : info.records?.detallevidencia[4]?.statusEvidencia === "1"
              ? "2"
              : info.records?.detallevidencia[4]?.statusEvidencia;

        const onFailure = ({ error, config }) => {
          alert("Ocurrio un error", error);
          //console.log(error);
          getBitacora(config, "Editar cierre de dia", error);
        };
        const onSuccess = ({ data, config }) => {
          getBitacora(config, "Editar cierre de dia", data);
          {
            data.statusCode !== 200
              ? alert(data.error)
              : (alert("Envio exitoso"),
                setDatosEnviados(true),
                setFormData({
                  VTotal: "",
                  ticket: "",
                  depostitoTombola: "",
                  propinpor: "",
                  nombre: "",
                  amex: "",
                  tpv: "",
                  pinpad: "",
                  vales: "",
                  valescdmx: "",
                  delivery: "",
                  didi: "",
                  didicredito: "",
                  rappi: "",
                  rapicargo: "",
                  uber: "",
                  uberdirect: "",
                  mercadopago: "",
                  wow: "",
                  mop: "",
                  startbuckRegords: "",
                  scanpay: "",
                  bkapp: "",
                  eventosWalmart: "",
                  eventosEmpresariales: "",
                  efectivomxp: "",
                  efectivousd: "",
                  didiEfectivo: "",
                  uberEfectivo: "",
                  rappiEfectivo: "",
                  anticipoOtrosCreditos: "",
                  otrosCreditos: "",
                  deliverySr: "",
                }),
                setformDataNoSuma({
                  VTotal: "",
                  ticket: "",
                  depostitoTombola: "",
                  propinpor: "",
                }),
                setImageDepositoURL(null),
                setImageValoresURL(null),
                setImageURL(null),
                setImageCofreElectronicoURL(null),
                setImageReporteVentasURL(null),
                setNombre(""),
                setComentario(""),
                setnoTicket(""),
                setSuma(""));
          }
          try {
            const saveDataLocal = `formData-${fecha}`;
            localStorage.removeItem(saveDataLocal);
            // console.log(`Datos borrandos de formData-${fecha}`);
          } catch (error) {
            // console.log("problemas al borrar los datos");
          }
        };

        fetchReclasificacionEdit(
          Number(branchFiPaisId),
          Number(brandfiMarcaId),
          branchFiSucursalId, //sucursal ID
          branchFcNombre,
          Number(formDataNoSuma.VTotal),
          Number(formDataNoSuma.depostitoTombola),
          Number(efectivoDepositar),
          nombre,
          info.records.fechaRegistro,
          hoyfecha,
          deviceInfo,
          Number(propinatotal),
          Number(porpropina),
          imageURL,
          depositoImg,
          valoresImg,
          cofreElectronicoImg,
          reporteVentasImg,
          ticketno,
          Number(locationLatitude),
          Number(locationLongitude),
          comentText,
          Number(formData.amex),
          Number(formData.tpv),
          Number(formData.pinpad),
          Number(formData.vales),
          Number(formData.valescdmx),
          Number(formData.delivery),
          Number(formData.didi),
          Number(formData.didicredito),
          Number(formData.rappi),
          Number(formData.rapicargo),
          Number(formData.uber),
          Number(formData.uberdirect),
          Number(formData.mercadopago),
          Number(formData.wow),
          Number(mop),
          Number(startbuckRe),
          Number(scanypay),
          Number(bkapp),
          Number(eventosWalmart),
          Number(eventosEmpresariales),
          Number(formData.efectivomxp),
          Number(efectivousd),
          Number(didiEfectivo),
          Number(uberEfectivo),
          Number(rappiEfectivo),
          Number(anticioOtros),
          Number(otrosCreditos),
          Number(deliverySr),
          info.records?.detallevidencia[0].comentario,
          ImagenChangeCierre,
          cierreType,
          cierreFecha,
          info.records?.detallevidencia[1].comentario,
          ImagenChangeFicha,
          fichaType,
          fichaFecha,
          info.records?.detallevidencia[2].comentario,
          ImagenChangeValores,
          valoresType,
          valoresFecha,
          info.records?.detallevidencia[3]?.comentario || "",
          ImagenChangeCofreElectronico,
          cofreElectronicoType,
          cofreElectronicoFecha,
          info.records?.detallevidencia[4]?.comentario || "",
          ImagenChangeReporteVentas,
          reporteVentasType,
          reporteVentasFecha
        )
          .then(onSuccess)
          .catch(onFailure);
      }
    }
  };

  return (
    <div className="">
      {/* --- 1. HEADER AZUL --- */}
      <div className="cd-header-row">
        <div className="cd-header-box full-width">
          <div className="cd-label-header">Venta Total</div>
          <NumericFormat
            name="VTotal"
            value={formDataNoSuma.VTotal}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            prefix={"$"}
            onValueChange={(values) => handleChangeNoSuma(values, "VTotal")}
            className={`cd-input-header ${errors.VTotal ? "cd-input-error" : ""}`}
            required
          />
          {errors && (
            <div className="cd-error-msg" style={{ color: "#ff8a80" }}>
              {errors.VTotal}
            </div>
          )}
        </div>
      </div>

      <div className="cd-section-title">Formas de pago</div>

      {/* --- 2. GRID PRINCIPAL (2 Columnas) --- */}
      <div className="cd-grid-main">
        {/* === COLUMNA IZQUIERDA === */}
        <div className="cd-col">
          {/* CARD: TARJETAS */}
          <div className="cd-card">
            <div className="cd-card-header">
              <img src={iconTarjetas} /> Tarjetas
            </div>
            <div className="cd-card-body">
              <div className="cd-grid-3">
                {formasPago.some((item) => item === 1) && (
                  <div className="cd-input-group">
                    <label className="cd-label">AMEX</label>
                    <NumericFormat
                      name="amex"
                      value={formData.amex}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "amex")}
                      className={`cd-input ${errors.amex ? "cd-input-error" : ""}`}
                    />
                    {errors?.amex && <div className="cd-error-msg">{errors.amex}</div>}
                  </div>
                )}
                {formasPago.some((item) => item === 2) && (
                  <div className="cd-input-group">
                    <label className="cd-label">TPV</label>
                    <NumericFormat
                      name="tpv"
                      value={formData.tpv}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "tpv")}
                      className={`cd-input ${errors.tpv ? "cd-input-error" : ""}`}
                    />
                    {errors?.tpv && <div className="cd-error-msg">{errors.tpv}</div>}
                  </div>
                )}
                {formasPago.some((item) => item === 3) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Pin pad</label>
                    <NumericFormat
                      name="pinpad"
                      value={formData.pinpad}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "pinpad")}
                      className={`cd-input ${errors.pinpad ? "cd-input-error" : ""}`}
                    />
                    {errors?.pinpad && <div className="cd-error-msg">{errors.pinpad}</div>}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* CARD: AGREGADORES */}
          <div className="cd-card">
            <div className="cd-card-header">
              <img src={iconAgregaores} alt="" /> Agregadores
            </div>
            <div className="cd-card-body">
              <div className="cd-grid-2">
                {formasPago.some((item) => item === 6) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Delivery Alsea</label>
                    <NumericFormat
                      name="delivery"
                      value={formData.delivery}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "delivery")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 29) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Delivery Sr</label>
                    <NumericFormat
                      name="deliverySr"
                      value={formData.deliverySr}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "deliverySr")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 9) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Rappi</label>
                    <NumericFormat
                      name="rappi"
                      value={formData.rappi}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "rappi")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 10) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Rappi cargo</label>
                    <NumericFormat
                      name="rapicargo"
                      value={formData.rapicargo}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "rapicargo")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 7) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Didi</label>
                    <NumericFormat
                      name="didi"
                      value={formData.didi}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "didi")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 8) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Didi Crédito</label>
                    <NumericFormat
                      name="didicredito"
                      value={formData.didicredito}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "didicredito")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 11) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Uber</label>
                    <NumericFormat
                      name="uber"
                      value={formData.uber}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "uber")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 12) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Uber Direct</label>
                    <NumericFormat
                      name="uberdirect"
                      value={formData.uberdirect}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "uberdirect")}
                      className="cd-input"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* === COLUMNA DERECHA === */}
        <div className="cd-col">
          {/* CARD: VALES */}
          <div className="cd-card">
            <div className="cd-card-header">
              <img src={iconValesFisicos} alt="" /> Vales físicos
            </div>
            <div className="cd-card-body">
              <div className="cd-grid-2">
                {formasPago.some((item) => item === 4) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Vales</label>
                    <NumericFormat
                      name="vales"
                      value={formData.vales}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "vales")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 5) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Vales CDMX</label>
                    <NumericFormat
                      name="valescdmx"
                      value={formData.valescdmx}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "valescdmx")}
                      className="cd-input"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* CARD: OTROS */}
          <div className="cd-card">
            <div className="cd-card-header">
              <img src={iconOtros} alt="" />
              Otros
            </div>
            <div className="cd-card-body">
              <div className="cd-grid-3">
                {formasPago.some((item) => item === 13) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Mercado pago</label>
                    <NumericFormat
                      name="mercadopago"
                      value={formData.mercadopago}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "mercadopago")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 14) && (
                  <div className="cd-input-group">
                    <label className="cd-label">WOW</label>
                    <NumericFormat
                      name="wow"
                      value={formData.wow}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "wow")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 15) && (
                  <div className="cd-input-group">
                    <label className="cd-label">MOP</label>
                    <NumericFormat
                      name="mop"
                      value={formData.mop}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "mop")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 16) && (
                  <div className="cd-input-group" style={{ gridColumn: "span 2" }}>
                    <label className="cd-label">Starbucks Rewards</label>
                    <NumericFormat
                      name="startbuckRegords"
                      value={formData.startbuckRegords}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "startbuckRegords")}
                      className="cd-input"
                    />
                  </div>
                )}
                {formasPago.some((item) => item === 17) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Scan & Pay</label>
                    <NumericFormat
                      name="scanpay"
                      value={formData.scanpay}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "scanpay")}
                      className="cd-input"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* CARD: EFECTIVO (Con botón rosa) */}
          <div className="cd-card">
            <div className="cd-card-header">
              <img src={iconEfectivo} alt="" /> Efectivo
            </div>
            <div className="cd-card-body">
              <div className="cd-grid-2">
                {formasPago.some((item) => item === 21) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Efectivo</label>
                    <div className="input-with-button">
                      <NumericFormat
                        name="efectivomxp"
                        value={formData.efectivomxp}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                        onValueChange={(values) => handleValueChange(values, "efectivomxp")}
                        className="cd-input"
                      />
                    </div>
                  </div>
                )}
                {formasPago.some((item) => item === 22) && (
                  <div className="cd-input-group">
                    <label className="cd-label">Efectivo USD</label>
                    <NumericFormat
                      name="efectivousd"
                      value={formData.efectivousd}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix={"$"}
                      onValueChange={(values) => handleValueChange(values, "efectivousd")}
                      className="cd-input"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- 3. BANNER TOTAL (AZUL) --- */}
      <div className="cd-banner-total">
        <div className="cd-banner-text">Total formas de pago:</div>
        <div className="cd-banner-amount">
          <NumericFormat
            value={suma}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$ "}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </div>
      </div>

      {/* --- 4. DEPÓSITOS EN EFECTIVO --- */}
      <div className="cd-card">
        <div className="cd-card-header">
          <img src={iconDepositosEfectivo} alt="" />
          Depositos en efectivo
        </div>
        <div className="cd-card-body">
          <div className="cd-grid-3">
            <div className="cd-input-group">
              <label className="cd-label">Depósitos en tombola</label>
              <div className="input-with-button">
                <NumericFormat
                  name="depostitoTombola"
                  value={formDataNoSuma.depostitoTombola}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"$"}
                  onValueChange={(values) => handleChangeNoSuma(values, "depostitoTombola")}
                  className="cd-input"
                />
              </div>
              {errors?.depostitoTombola && (
                <div className="cd-error-msg">{errors.depostitoTombola}</div>
              )}
            </div>

            <div className="cd-input-group">
              <label className="cd-label">Efectivo a depositar</label>
              <NumericFormat
                name="efectivoDepositar"
                value={efectivoDepositar}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                prefix={"$"}
                className="cd-input"
                disabled
              />
            </div>

            {/* Asumiendo que Efectivo USD aquí es visual o repetido, uso un input deshabilitado o si tienes otra variable usala. Si no, quítalo */}
            <div className="cd-input-group">
              <label className="cd-label">Efectivo USD</label>
              <NumericFormat
                value={formData.efectivousd}
                displayType="input"
                className="cd-input"
                disabled
                prefix="$"
              />
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <label className="cd-label">Comentarios</label>
            <textarea
              value={comentario}
              onChange={handleChangeComentario}
              placeholder="Escribe aquí un comentario"
              rows={4}
              maxLength={300}
              className="cd-textarea"
            />
          </div>
        </div>
      </div>

      {/* --- 5. EVIDENCIAS Y GUARDAR (PIE DE PÁGINA) --- */}
      <div className="row">
        {/* Lado Izquierdo: Botones Rosas de Evidencia */}
          <div className="col-sm-12 col-md-6">
            <div className="row">
              <div className="col-4 col-buttons">
                <button className="cd-btn-evidence" onClick={() => setModalVisible(true)}>
                  <img
                      className="icon-reclasificacin"
                      src={iconPinPad}
                      alt="icon"
                      style={{ width: "24px", height: "24px", filter: "brightness(0) invert(1)" }}
                  />
                  <span>Cierre de Lote-Pinpad</span>
                </button>

                <>
                  {isShowImage ? (
                      <LoadingSpinner />
                  ) : (
                      <div>
                        {imageURL && (
                            <>
                              <Image width={80} src={`${imageURL}?${new Date().getTime()}`} alt="Logo" />
                              <div className="font-text-bold">Estatus:</div>
                              {info.records?.detallevidencia[0].statusEvidencia === "0" ? (
                                  <div className="font-text-bold">Inicial</div>
                              ) : info.records?.detallevidencia[0].statusEvidencia === "1" ? (
                                  <div className="font-text-boldRed">Rechazado</div>
                              ) : info.records?.detallevidencia[0].statusEvidencia === "2" ? (
                                  <div className="font-text-boldGreen">Reenviado</div>
                              ) : (
                                  ""
                              )}
                            </>
                        )}
                      </div>
                  )}
                </>
              </div>

              <div className="col-4 col-buttons">
                <button className="cd-btn-evidence" onClick={() => setModalVisibleFicha(true)}>
                  <img
                      className="icon-reclasificacin"
                      src={iconFichaDeposito}
                      alt="icon"
                      style={{ width: "24px", height: "24px", filter: "brightness(0) invert(1)" }}
                  />
                  <span>Ficha de Depósito</span>
                </button>
                <>
                  {isShowImageDep ? (
                      <LoadingSpinner />
                  ) : (
                      <div>
                        {imageDepositoURL && (
                            <>
                              <Image
                                  width={80}
                                  src={`${imageDepositoURL}?${new Date().getTime()}`}
                                  alt="Logo"
                              />
                              <div className="font-text-bold">Estatus:</div>
                              {info.records?.detallevidencia[1].statusEvidencia === "0" ? (
                                  <div className="font-text-bold">Inicial</div>
                              ) : info.records?.detallevidencia[1].statusEvidencia === "1" ? (
                                  <div className="font-text-boldRed">Rechazado</div>
                              ) : info.records?.detallevidencia[1].statusEvidencia === "2" ? (
                                  <div className="font-text-boldGreen">Reenviado</div>
                              ) : (
                                  ""
                              )}
                            </>
                        )}
                      </div>
                  )}
                </>
              </div>

              <div className="col-4 col-buttons">
                <button className="cd-btn-evidence" onClick={() => setModalVisibleValores(true)}>
                  <img
                      className="icon-reclasificacin"
                      src={iconEntregaValores}
                      alt="icon"
                      style={{ width: "24px", height: "24px", filter: "brightness(0) invert(1)" }}
                  />
                  <span>Entrega de Valores</span>
                </button>
                <>
                  {isShowImageVal ? (
                      <LoadingSpinner />
                  ) : (
                      <div>
                        {imageValoresURL && (
                            <>
                              <Image
                                  width={80}
                                  src={`${imageValoresURL}?${new Date().getTime()}`}
                                  alt="Logo"
                              />
                              <div className="font-text-bold">Estatus:</div>
                              {info.records?.detallevidencia[2].statusEvidencia === "0" ? (
                                  <div className="font-text-bold">Inicial</div>
                              ) : info.records?.detallevidencia[2].statusEvidencia === "1" ? (
                                  <div className="font-text-boldRed">Rechazado</div>
                              ) : info.records?.detallevidencia[2].statusEvidencia === "2" ? (
                                  <div className="font-text-boldGreen">Reenviado</div>
                              ) : (
                                  ""
                              )}
                            </>
                        )}
                      </div>
                  )}
                </>
              </div>

              <div className="col-4 col-buttons">
                {shouldShowCofreElectronico && (
                    <button
                        className="cd-btn-evidence"
                        onClick={() => setModalVisibleCofreElectronico(true)}
                    >
                      <img
                          className="icon-reclasificacin"
                          src={iconCofreElectronico}
                          alt="icon"
                          style={{ width: "24px", height: "24px", filter: "brightness(0) invert(1)" }}
                      />
                      <span>Cofre Electrónico</span>
                    </button>
                )}
                <>
                  {isShowImageCofreElectronico ? (
                      <LoadingSpinner />
                  ) : (
                      <div>
                        {imageCofreElectronicoURL && (
                            <>
                              <Image
                                  width={80}
                                  src={`${imageCofreElectronicoURL}?${new Date().getTime()}`}
                                  alt="Logo"
                              />
                              <div className="font-text-bold">Estatus:</div>
                              {info.records?.detallevidencia[3]?.statusEvidencia === "0" ? (
                                  <div className="font-text-bold">Inicial</div>
                              ) : info.records?.detallevidencia[3]?.statusEvidencia === "1" ? (
                                  <div className="font-text-boldRed">Rechazado</div>
                              ) : info.records?.detallevidencia[3]?.statusEvidencia === "2" ? (
                                  <div className="font-text-boldGreen">Reenviado</div>
                              ) : (
                                  ""
                              )}
                            </>
                        )}
                      </div>
                  )}
                </>
              </div>

              <div className="col-4 col-buttons">
                <button
                    className="cd-btn-evidence"
                    onClick={() => setModalVisibleReporteVentas(true)}
                >
                  <img
                      className="icon-reclasificacin"
                      src={iconReporteVentas}
                      alt="icon"
                      style={{ width: "24px", height: "24px", filter: "brightness(0) invert(1)" }}
                  />
                  <span>Reporte de Ventas</span>
                </button>
                <>
                  {isShowImageReporteVentas ? (
                      <LoadingSpinner />
                  ) : (
                      <div>
                        {imageReporteVentasURL && (
                            <>
                              <Image
                                  width={80}
                                  src={`${imageReporteVentasURL}?${new Date().getTime()}`}
                                  alt="Logo"
                              />
                              <div className="font-text-bold">Estatus:</div>
                              {info.records?.detallevidencia[4]?.statusEvidencia === "0" ? (
                                  <div className="font-text-bold">Inicial</div>
                              ) : info.records?.detallevidencia[4]?.statusEvidencia === "1" ? (
                                  <div className="font-text-boldRed">Rechazado</div>
                              ) : info.records?.detallevidencia[4]?.statusEvidencia === "2" ? (
                                  <div className="font-text-boldGreen">Reenviado</div>
                              ) : (
                                  ""
                              )}
                            </>
                        )}
                      </div>
                  )}
                </>
              </div>
            </div>
          </div>

        <div className="col-sm-12 col-md-6">
          {/* Lado Derecho: Nombre y Botón Guardar */}
          <div className="cd-save-area">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="cd-label">Nombre</label>
              <input
                  type="text"
                  name="nombre"
                  value={nombre}
                  onChange={handleChangeNombre}
                  placeholder="Sergio Alexis Membrillo Cruz"
                  className="cd-input"
                  required
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button onClick={setSaveReclasificacionEdith} className="cd-btn-save">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mantenemos los modales al final, invisibles hasta que se activan */}
      <Modal open={modalVisible} onCancel={() => setModalVisible(false)} footer={null}>
        {/* ... contenido de tus modales (sin cambios) ... */}
        <div className="conteiner-modal-body-evidencias">
          {/* Pega aquí el contenido interno de tus modales tal cual lo tenías */}
        </div>
      </Modal>

      <Modal
        open={modalVisibleFicha}
        onCancel={() => setModalVisibleFicha(false)}
        footer={null}
      ></Modal>
      <Modal
        open={modalVisibleValores}
        onCancel={() => setModalVisibleValores(false)}
        footer={null}
      ></Modal>
    </div>
  );
};
